/**
 * Módulo: FAQ
 * Toggle accordion das perguntas frequentes com animação suave.
 */

export function initFaq() {
  const items = document.querySelectorAll('.faq__item');

  if (!items.length) return;

  items.forEach(item => {
    const btn = item.querySelector('.faq__pergunta');
    const resposta = item.querySelector('.faq__resposta');

    if (!btn || !resposta) return;

    btn.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      // Fecha todos os outros itens
      items.forEach(other => {
        if (other !== item && other.classList.contains('is-open')) {
          other.classList.remove('is-open');
          const otherBtn = other.querySelector('.faq__pergunta');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          const otherResp = other.querySelector('.faq__resposta');
          if (otherResp) otherResp.style.maxHeight = '0';
        }
      });

      // Toggle do item atual
      if (isOpen) {
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        resposta.style.maxHeight = '0';
      } else {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        resposta.style.maxHeight = resposta.scrollHeight + 'px';
      }
    });
  });
}
